import { render, staticRenderFns } from "./position_rates.vue?vue&type=template&id=0aa3f19b&scoped=true"
import script from "./position_rates.vue?vue&type=script&lang=js"
export * from "./position_rates.vue?vue&type=script&lang=js"
import style0 from "./position_rates.vue?vue&type=style&index=0&id=0aa3f19b&prod&scoped=true&lang=scss"
import style1 from "./position_rates.vue?vue&type=style&index=1&id=0aa3f19b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa3f19b",
  null
  
)

export default component.exports